function showFhSwitchModal(fromName, toName) {
    return new Promise((resolve) => {
        const modal = document.getElementById('fh-switch-modal');
        const modalMessage = document.getElementById('fh-switch-message');
        const confirmBtn = document.getElementById('fh-switch-confirm');
        const cancelBtn = document.getElementById('fh-switch-cancel');
        const loader = document.getElementById('page-loader');

        if (loader) loader.style.display = 'none';
        modalMessage.textContent =
            `You're switching from ${fromName} to ${toName}. ` +
            modalMessage.textContent;

        modal.classList.remove('hidden');
        document.body.classList.add('fh-modal-open');

        const close = (result) => {
            modal.classList.add('hidden');
            document.body.classList.remove('fh-modal-open');
            confirmBtn.removeEventListener('click', onConfirm);
            cancelBtn.removeEventListener('click', onCancel);
            resolve(result);
        };

        const onConfirm = () => close(true);
        const onCancel = () => close(false);

        confirmBtn.addEventListener('click', onConfirm);
        cancelBtn.addEventListener('click', onCancel);
    });
}
